module.exports = __webpack_public_path__ + "static/img/159.ebfa8f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/159.png
// module id = YaPD
// module chunks = 0